"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// TODO create a proper app builder so it can build any react node as application
const client_1 = require("react-dom/client");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const YoutubeUploader_1 = require("./YoutubeUploader");
class App {
    constructor(onImport, options) {
        var _a;
        this.appId = 'youtube-upload-app';
        this.targetNodeSelector = 'body';
        this.onImport = onImport;
        this.theme = (_a = options === null || options === void 0 ? void 0 : options.theme) !== null && _a !== void 0 ? _a : ui_common_components_1.Theme;
    }
    createDOMNode() {
        const container = document.getElementById(this.appId);
        if (container)
            return container;
        const targetNode = document.querySelector(this.targetNodeSelector);
        const app = document.createElement('div');
        if (!targetNode)
            return;
        app.id = this.appId;
        targetNode.appendChild(app);
        return document.getElementById(app.id);
    }
    mountApp() {
        const node = this.createDOMNode();
        if (!node)
            return;
        const handleImport = (url) => {
            this.onImport(url);
            this.closeApp();
        };
        this.root = (0, client_1.createRoot)(node);
        this.root.render((0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: this.theme, children: (0, jsx_runtime_1.jsx)(YoutubeUploader_1.YoutubeUploader, { onImport: (url) => handleImport(url), onCancel: () => {
                    this.closeApp();
                } }) }));
    }
    closeApp() {
        if (!this.root)
            return;
        this.root.unmount();
        this.root = null;
    }
}
exports.App = App;
//# sourceMappingURL=App.js.map